import { render, staticRenderFns } from "./ColorDot.vue?vue&type=template&id=439322d7&scoped=true&functional=true&"
import script from "./ColorDot.vue?vue&type=script&lang=js&"
export * from "./ColorDot.vue?vue&type=script&lang=js&"
import style0 from "./ColorDot.vue?vue&type=style&index=0&id=439322d7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "439322d7",
  null
  
)

export default component.exports